<script lang="ts">
	import type { ClassValue } from 'svelte/elements';

	let {
		class: className
	}: {
		class?: ClassValue;
	} = $props();
</script>

<div class={className}>
	<div class="w-2 h-2 bg-primary rounded-full"></div>
	<div class="sr-only">New updates</div>
</div>
